(ns ui.view.card.associated-entities.view
  (:require
   [common.localization :as loc]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [ui.components.button.view :as button]
   [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]
   [ui.util :as uu]
   [ui.view.card.associated-entities.associated-entities-table :as associated-entities-table]
   [ui.view.card.associated-entities.entity-peek :as entity-peek-view]
   [ui.view.card.associated-entities.event :as event]
   [ui.view.card.associated-entities.sub :as sub]
   [ui.view.card.entity-list.view :as entity-list-view]
   [ui.view.card.event :as common-event]
   [ui.view.card.shared-components.card-container :as card-container]
   [ui.view.card.shared-components.card-title :as card-title]
   [ui.view.card.shared-components.full-screen-card :as full-screen-card]
   [ui.view.card.shared-components.view :as card-shared]
   [ui.view.card.sub :as common-card-sub]))

(defn loading-error-view
  []
  [:div
   {:class "h-56 flex flex-col items-center justify-center"}
   [:p (loc/tr :error-loading-data)]])

(defn add-association-dropdown
  [{:keys [card set-open primary-button? ctx]}]
  (let [options @(rf/subscribe [::sub/add-association-options card])
        options (->> options
                     (mapv (fn [{:keys [value] :as opt}]
                             (let [target-entity-type value]
                               (assoc opt :on-click
                                      #(rf/dispatch [::event/open-add-association-modal ctx target-entity-type]))))))
        trigger-comp (if primary-button?
                       button/sm-primary-solid
                       button/sm-secondary-hollow)]
    [dropdown-menu/view
     {:items          options
      :on-open-change (fn [open?]
                        (when (fn? set-open)
                          (set-open open?)))
      :props          {:hide-arrow? true
                       :align       :end}
      :trigger-as-child
      [:span
       [trigger-comp
        {}
        [:i.fal.fa-plus]
        (loc/tr :add-association)]]}]))

(defn empty-state-view
  [props]
  [:div
   {:class "py-5 flex items-center justify-center w-full"}
   [:div
    {:class "flex flex-col gap-3 items-center"}
    [:p
     {:class "font-semibold"}
     (loc/tr :no-associations-yet)]
    [add-association-dropdown
     (assoc props :primary-button? true)]]])

(defn entity-peek-wrapper
  [{:keys [full-screen? ctx]}]
  (let [peek-data @(rf/subscribe [::sub/entity-peek-data ctx])
        close-entity-peek (fn []
                            (rf/dispatch [::common-event/close-entity-peek ctx]))]
    [entity-peek-view/view
     (merge
      peek-data
      {:full-screen? full-screen?
       :on-close     close-entity-peek})]))

(defn content-view
  [{:keys [ctx card] :as props}]
  (let [visible-tables @(rf/subscribe [::sub/visible-tables ctx])
        all-tables (get-in card [:card/config :tables])]
    [:div
     {:class "flex min-h-full"}
     (if (seq visible-tables)
       [:div
        {:class "grow flex flex-col gap-2"}
        (->> all-tables
             (map-indexed
              (fn [table-index table]
                (let [visible? @(rf/subscribe [::sub/table-visible? ctx table-index])]
                  ^{:key (str "t-" table-index)}
                  [:div
                   {:class (uu/cm (when-not visible?
                                    "hidden"))}
                   [associated-entities-table/view
                    (assoc props
                           :table table
                           :table-index table-index)]])))
             (doall))]
       [empty-state-view props])
     [entity-peek-wrapper props]]))

(defn card-body
  [{:keys [loading? loading-error?] :as props}]
  (cond
    loading? [entity-list-view/loading-skeleton]
    loading-error? [loading-error-view]
    :else [content-view props]))

(defn component
  [_props]
  (let [dropdown-open-state (r/atom false)]
    (fn [{:keys [card preview-mode? ctx] :as props}]
      (let [title (:card/title card)
            visible-tables @(rf/subscribe [::sub/visible-tables ctx])]
        [card-container/view
         [:div
          {:class "flex flex-col gap-2"}
          [:div
           {:class "flex justify-between items-center"}
           [card-title/view title]
           (when-not preview-mode?
             [:div
              {:class (uu/cm "opacity-0 group-hover/card:opacity-100 transition-opacity flex gap-2"
                             (when @dropdown-open-state
                               "opacity-100"))}
              (when (seq visible-tables)
                [add-association-dropdown
                 (assoc props
                        :set-open #(reset! dropdown-open-state %))])
              [card-shared/expand-card props]])]
          [card-body props]]]))))

(defn full-screen-component
  [props]
  [full-screen-card/view
   (merge
    props
    {:header-right-actions
     [:<>
      [add-association-dropdown props]]})
   [card-body props]])

(defn view
  [{:keys [card entity-id full-screen? ctx] :as props}]
  (let [loading? @(rf/subscribe [::common-card-sub/loading? ctx])
        loading-error? @(rf/subscribe [::common-card-sub/loading-error? ctx])
        props (merge
               props
               {:card           card
                :entity-id      entity-id
                :loading?       loading?
                :loading-error? loading-error?})]
    (if full-screen?
      [full-screen-component props]
      [component props])))


